"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tagTester = _interopRequireDefault(require("./_tagTester.js"));

var _isFunction = _interopRequireDefault(require("./isFunction.js"));

var _isArrayBuffer = _interopRequireDefault(require("./isArrayBuffer.js"));

var _stringTagBug = require("./_stringTagBug.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDataView = (0, _tagTester.default)('DataView'); // In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.

function ie10IsDataView(obj) {
  return obj != null && (0, _isFunction.default)(obj.getInt8) && (0, _isArrayBuffer.default)(obj.buffer);
}

var _default = _stringTagBug.hasStringTagBug ? ie10IsDataView : isDataView;

exports.default = _default;